export default "__VITE_ASSET__1Gz7CgZC__"